import React from 'react';
import { TouchableOpacity } from 'react-native-gesture-handler';

import { common } from '@/styles/styles';

import CheckboxRoundedEmpty from '../assets/icons/checkbox-rounded-empty';
import CheckboxRoundedSelected from '../assets/icons/checkbox-rounded-selected';

export const CheckboxRounded = ({ value, setValue }: { value: boolean; setValue: () => void }) => {
    return (
        <TouchableOpacity style={[common.row]} onPress={setValue}>
            {value ? <CheckboxRoundedSelected /> : <CheckboxRoundedEmpty />}
        </TouchableOpacity>
    );
};
